import { z } from 'zod';

export const LabelBlockSchema = z.object({
  main: z.string().trim(),
  subtitle: z.string().trim().optional(),
  description: z.string().trim().optional()
});

export type LabelBlock = z.infer<typeof LabelBlockSchema>;
